import React from 'react';
import { motion } from 'framer-motion';
import { FaQuoteLeft } from 'react-icons/fa';

const TestimonialCard = ({ quote, author, company, rating }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.05, boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)" }}
      className="p-8 bg-white rounded-xl shadow-lg border border-gray-300 transition-all duration-300"
    >
      {/* Quotation Mark */}
      <motion.div 
        whileHover={{ scale: 1.1 }}
        animate={{ y: [0, -5, 0] }}
        transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
        className="text-5xl text-yellow-600 mx-auto mb-4"
      >
        <FaQuoteLeft />
      </motion.div>

      {/* Quote Text */}
      <p className="text-gray-700 italic leading-relaxed mb-4">"{quote}"</p>

      {/* Author & Company */}
      <h3 className="text-xl font-bold text-gray-900">{author}</h3>
      <p className="text-gray-600">{company}</p>

      {/* Star Rating with Animation */}
      <div className="flex gap-1 mt-3 justify-center">
        {Array.from({ length: rating }, (_, index) => (
          <motion.svg
            key={index}
            className="w-5 h-5 text-yellow-500"
            fill="currentColor"
            viewBox="0 0 20 20"
            whileHover={{ scale: 1.2 }}
            transition={{ duration: 0.2 }}
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.974a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.385 2.46a1 1 0 00-.364 1.118l1.287 3.974c.3.921-.755 1.688-1.54 1.118l-3.385-2.46a1 1 0 00-1.175 0l-3.385 2.46c-.784.57-1.838-.197-1.54-1.118l1.287-3.974a1 1 0 00-.364-1.118L2.245 9.4c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.974z" />
          </motion.svg>
        ))}
      </div>
    </motion.div>
  );
};

export default TestimonialCard;
